export default "__VITE_ASSET__bpMJ4NQc__"